<script setup lang="ts">
import WhoAreYou from "./components/level1/who-are-you/who-are-you.vue"
import TrustDetection from "./components/level1/trust-detection/trust-detection.vue"
import GlobalLoading from "./components/loaders/global-loading/global-loading.vue"
import { useApp } from "./hooks/useApp";
import { initLiuRouter } from "./routes/liu-router"
import {defineAsyncComponent, onMounted} from "vue"
import time from "~/utils/basic/time"
import {initWechatConfig, isInWx} from "~/utils/basic/wechat";
import {useSystemStore} from "~/hooks/stores/useSystemStore";
// import {invokeWxJsSdk} from "~/utils/third-party/weixin/handle-wx-js-sdk";
// import {useGlobalStateStore} from "~/hooks/stores/useGlobalStateStore";

time.whenAppSetup()

const CustomUi = defineAsyncComponent(() => {
  return import("./components/custom-ui/custom-ui.vue")
})

const { cha } = useApp()
const { route } = initLiuRouter()
const ios_ipad = Boolean(cha.isIOS || cha.isIPadOS)
const { supported_theme } = useSystemStore()
onMounted(async ()=>{
  if (isInWx()) {
    /*const res1 = await invokeWxJsSdk(1000)
    const gStore = useGlobalStateStore()
    console.log('app mounted wx config res:', res1)
    gStore.wxReady = true
    if(res1) {
      gStore.showWxSubscribeBtn = false
    }*/
    initWechatConfig()
  }
})
</script>

<template>
  <van-config-provider :theme="supported_theme">
    <div
        class="app-container"
        :class="{
      'liu-ios-device': ios_ipad,
      'liu-android-device': cha.isAndroid,
    }"
    >

      <!-- 侧边栏视图 -->
      <router-view name="LeftSidebar" v-slot="{ Component }">
        <keep-alive>
          <component :is="Component" />
        </keep-alive>
      </router-view>

      <!-- 默认视图 -->
      <router-view v-if="route.meta.keepAlive !== false" v-slot="{ Component }">
        <keep-alive>
          <component :is="Component" />
        </keep-alive>
      </router-view>
      <router-view v-else></router-view>

      <!-- router-view for bottom navigation bar -->
      <router-view name="BottomNaviBar" v-slot="{ Component }">
        <keep-alive>
          <component :is="Component" />
        </keep-alive>
      </router-view>

      <custom-ui />
      <who-are-you />
      <TrustDetection></TrustDetection>
      <GlobalLoading></GlobalLoading>
    </div>
  </van-config-provider>
</template>

<style scoped>

.app-container {
  height: max-content;
  min-height: 100%;
  min-width: 250px;
}

</style>
<style lang="scss">
body{
  .van-toast, .van-toast__text {
    user-select: none !important;
    -webkit-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
  }
}
</style>
